import client from '../../shared/api/client';

export interface P2pSettings {
  id: number;
  dispute_open_window_minutes: number;
  otc_dispute_open_window_minutes?: number;
  otc_min_verification_level?: number;
  otc_max_fiat_amount?: string | null;
  otc_default_time_limit?: number;
  otc_cash_verification_enabled?: boolean;
  otc_cash_min_samples?: number;
  otc_cash_seller_checks?: number;
  otc_cash_min_fiat_amount?: string | null;
  otc_cash_release_requires_check?: boolean;
  otc_cash_strict_serial_format?: boolean;
  created_at?: string;
  updated_at?: string;
}

interface SettingsBackendResponse<T> {
  status: string;
  data: T;
}

export const getP2pSettings = async (): Promise<P2pSettings> => {
  const response = await client.get<SettingsBackendResponse<P2pSettings>>('/p2p/settings');
  return response.data.data;
};

export const updateP2pSettings = async (input: {
  dispute_open_window_minutes?: number;
  otc_dispute_open_window_minutes?: number;
  otc_min_verification_level?: number;
  otc_max_fiat_amount?: string | null;
  otc_default_time_limit?: number;
  otc_cash_verification_enabled?: boolean;
  otc_cash_min_samples?: number;
  otc_cash_seller_checks?: number;
  otc_cash_min_fiat_amount?: string | null;
  otc_cash_release_requires_check?: boolean;
  otc_cash_strict_serial_format?: boolean;
}): Promise<P2pSettings> => {
  const response = await client.put<SettingsBackendResponse<P2pSettings>>('/p2p/settings', input);
  return response.data.data;
};
